import Vue from 'vue'
import Router from 'vue-router'

import Login from '@/components/Login'
import Register from '@/components/Register'
import ForgotPassword from '@/components/ForgotPassword'
import ResetPassword from '@/components/ResetPassword'
import Activation from '@/components/Activation'

import Private from '@/components/Private'
import Invitations from '@/components/Invitations'
import Products from '@/components/Products'
import Userdetails from '@/components/Userdetails'
import Recipients from '@/components/Recipients'
import Cart from '@/components/Cart'
import Checkout from '@/components/Checkout'
import OrderSuccess from '@/components/OrderSuccess'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'Home',
      component: Login
    },
    {
      path: '/orderComplete',
      name: 'OrderSuccess',
      component: OrderSuccess
    },
    {
      path: '/products',
      name: 'Products',
      component: Products
    },
    {
      path: '/login',
      name: 'Login',
      component: Login
    },
    {
      path: '/register/:invite_token',
      name: 'Register',
      component: Register
    },
    {
      path: '/forgot-password',
      name: 'ForgotPassword',
      component: ForgotPassword
    },
    {
      path: '/reset-password',
      name: 'ResetPassword',
      component: ResetPassword
    },

    {
      path: '/activation/:id',
      name: 'Activation',
      component: Activation
    },
    {
      path: '/private',
      name: 'Private',
      component: Private
    
    },
    {
      path: '/invitations',
      name: 'Invitations',
      component: Invitations
    
    },
    {
      path: '/Userdetails',
      name: 'Userdetails',
      component: Userdetails
    
    },
    {
      path: '/Cart',
      name: 'Cart',
      component: Cart
    
    },
    {
      path: '/Checkout',
      name: 'Checkout',
      component: Checkout
    
    },
    {
      path: '/recipients',
      name: 'Recipients',
      component: Recipients
    
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js